<template>
  <div class="circle-bd">
    <svg viewBox="0 0 100 100">
      <path :d="pathString" :stroke="trailColor" :stroke-width="trailWidth" :fill-opacity="0" />
      <path :d="pathString" :stroke-linecap="strokeLinecap" :stroke="strokeColor" :stroke-width="strokeWidth" fill-opacity="0" :style="pathStyle" />
    </svg>
    <div class="circle-content">
      <slot></slot>
    </div>
  </div>
</template>
<!-- <t-circle :trailWidth="1" trailColor="#d9d9d9" :strokeWidth="6" strokeColor="#f4b357" :percent="num">80%</t-circle> -->
<script>
export default {
  name: 'tCircle',
  props: {
    strokeWidth: { // 线条宽度（外圆）
      type: Number,
      default: 1,
    },
    strokeColor: { // 线条颜色（外圆）
      type: String,
      default: '#3FC7FA',
    },
    trailWidth: { // 线条宽度（内圆）
      type: Number,
      default: 1,
    },
    trailColor: { // 线条颜色（内圆）
      type: String,
      default: '#D9D9D9',
    },
    percent: {
      type: Number,
      default: 0,
    },
    strokeLinecap: {
      type: String,
      default: 'round',
    },
  },
  computed: {
    radius() {
      return 50 - this.strokeWidth / 2;
    },
    pathString() {
      return `M 50,50 m 0,-${this.radius}
      a ${this.radius},${this.radius} 0 1 1 0,${2 * this.radius}
      a ${this.radius},${this.radius} 0 1 1 0,-${2 * this.radius}`;
    },
    len() {
      return Math.PI * 2 * this.radius;
    },
    pathStyle() {
      return {
        'stroke-dasharray': `${this.len}px ${this.len}px`,
        'stroke-dashoffset': `${((100 - this.percent) / 100 * this.len)}px`,
        '-webkit-transition': 'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease',
        // 'transition': 'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease',
      };
    },
  },
};

</script>
<style lang="scss">
.circle-bd {
  position: relative;
  width: 100%;
  height: 100%;
}

.circle-content {
  width: 100%;
  text-align: center;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

</style>



// WEBPACK FOOTER //
// src/components/custom/circle.vue